<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { getErrorMessages } from '@/helpers';

@Component({
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    loading(val) {
      this.isProcessing = val;
    },
  },
})
export default class FormBase extends Vue {
  errorMessage = null;
  isProcessing = false;

  created() {
    this.isProcessing = this.loading;
  }

  get isFormDirty() {
    return Object.keys(this.fields).some(key => this.fields[key].dirty);
  }

  getFieldName(name, scope) {
    return `${scope}.${name}`;
  }

  getVValidate(rules = '') {
    const rulesObject = {
      max: 255,
    };
    if (typeof rules === 'object') {
      Object.keys(rules).forEach(rule => {
        rulesObject[rule] = rules[rule];
      });
    } else {
      rules
        .trim()
        .split('|')
        .forEach(rule => {
          if (!rule || rule.length === 0) return;
          const parts = rule.split(':');
          rulesObject[parts[0]] = parts[1] === undefined ? true : parts[1];
        });
    }
    return {
      rules: rulesObject,
      scope: this.formScope || this.$options.name,
    };
  }

  async formValidate() {
    this.errorMessage = null;
    this.isProcessing = true;
    const isValid = await this.$validator.validate();
    if (isValid) {
      this.$emit('submit', this.form);
    }
    this.isProcessing = false;
  }

  setError(errorMessage) {
    this.errorMessage = errorMessage;
  }

  resetError() {
    this.errorMessage = null;
  }

  getErrorMessages(fieldName, fieldNamePretty) {
    return getErrorMessages(this.errors, fieldName, fieldNamePretty);
  }
}
</script>
